
      import mapsIntegration from './utils/maps-integration.ts';
      
      // Initialize maps integration
      // - Creates action buttons for Google Maps, Street View, OSM, Waze
      // - Observes coordinate updates
      // - Handles deep linking for native apps
      mapsIntegration.init();
    